<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-if="dialogShow"
    v-model="dialogShow"
    class="items-no-padding bank-edit sidebar-dialog">
    <div class="sidebar-content h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
          <el-form-item
              :label="$t('User.receivingCurrency')"
            >
              <el-select
                style="width: 100%;"
                :placeholder="$t('root.selectPls')"
                v-model="form.currency"
                @change = "getBankList"
                filterable
              >
                <el-option
                  v-for="(option,index) in listOfCurrencies"
                  :key="index"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
             
            
              :label="$t('User.bankName')"
              prop="bankName"
            >
              <el-select
                style="width: 100%;"
                :placeholder="$t('root.selectPls')"
                v-model="form.bankName"
                filterable
              >
                <el-option
                  v-for="(option,index) in bankList"
                  :key="index"
                  :label="option.label"
                  :value="option.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="bankNameIsOtherBank"
              :label="$t('Bank_Name')"
              prop="bankNameNoMatchBank"
            >
              <el-input
                v-model="form.bankNameNoMatchBank"
                :placeholder="phFileter('Bank_Name')"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('User.bankAccount')"
              prop="bankAccount"
            >
              <el-input
                type="number"
                v-model.trim="form.bankAccount"
                :placeholder="phFileter('User.plsInputBankAccount')"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('User.bankOutlet')"
              prop="bankOutlet"
            >
              <el-input v-model="form.bankOutlet" :placeholder="phFileter('User.plsInputBankOutlet')"></el-input>
            </el-form-item>
            <el-form-item
              label="SwiftCode"
              prop="swiftCode"
            >
              <el-input v-model="form.swiftCode" :placeholder="phFileter('User.plsInputSwiftCode')"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Bank_card_front')"
              prop="bankFrontUrl"
            >
              <upload-img-tips></upload-img-tips>
              <div class="upload-box pr">
                <MobileImageUpload
                  :value="form.bankFrontUrl"
                  @input="(url) => { form.bankFrontUrl = url }"
                  @success="(url) => { form.bankFrontUrl = url }"
                >
                  <img
                    v-if="form.bankFrontUrl"
                    :src="form.bankFrontUrl"
                    class="avatar middle"
                  >
                  <div v-else class="avatar-uploader-btn">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <span>{{$t('Upload_positive')}}</span>
                  </div>
                </MobileImageUpload>
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('Bank_card_reverse_side')"
              prop="bankBackUrl"
            >
              <upload-img-tips></upload-img-tips>
              <div class="upload-box pr">
                <MobileImageUpload
                  :value="form.bankBackUrl"
                  @input="(url) => { form.bankBackUrl = url }"
                  @success="(url) => { form.bankBackUrl = url }"
                >
                  <img
                    v-if="form.bankBackUrl"
                    :src="form.bankBackUrl"
                    class="avatar middle"
                  >
                  <div v-else class="avatar-uploader-btn">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <span>{{$t('Upload_negative')}}</span>
                  </div>
                </MobileImageUpload>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        :disabled="btnDisabled"
        @click="submitHandle"
        color="primary"
      >{{$t('User.sumit')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { getDictListByType } from "@/api/home";
import { limitImageSizeFormat } from "@/utils/common";
import { commitBankcardImg,getCustPayTypes } from '@/api/user.js';
import { mapGetters, mapActions } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "bankInfoEditDialog",
  components:{
    VuePerfectScrollbar
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('User.bankCardInfo'),
      bankListLoaded: false,
      form:{
        bankAccount: '',
        bankName: '',
        bankNameNoMatchBank: '',
        bankOutlet: '',
        swiftCode: '',
        bankFrontUrl: '',
        bankBackUrl: '',
        currency:'CNY'
      },
      rules: {
        bankAccount: [
          { required: true, message: this.$t('User.plsInputBankAccount'), trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: this.$t('User.plsInputBankName'), trigger: 'blur' }
        ],
        bankNameNoMatchBank: [
          { required: true, message: this.$t('User.plsInputBankName'), trigger: 'blur' }
        ],
        bankOutlet: [
          { required: true, message: this.$t('User.plsInputBankOutlet'), trigger: 'blur' }
        ],
        // swiftCode: [
        //   { required: true, message: this.$t('User.plsInputSwiftCode'), trigger: 'blur' }
        // ],
        bankFrontUrl: [
          { required: true, message: this.$t('Please_upload'), trigger: 'change' }
        ],
        bankBackUrl: [
          { required: true, message: this.$t('Please_upload'), trigger: 'change' }
        ],
      },
      getUser: {
        id: ''
      },
      allData:{},
      bankList: [],
      listOfCurrencies:[{label:this.$t('User.CNYNAME'),value:"CNY"},
      {label:this.$t('User.VNDNAME'),value:"VND"},{label:this.$t('User.Rpcurrency'),value:"IDR"}],
      frontLoading: false,
      backLoading: false,
    }
  },

  computed: {
    ...mapGetters(['userInfo','language','custPayTypes']),
    btnDisabled() {
      let flag = false;
      let key;
      for(key in this.form){
        if(!this.form[key] && key != 'swiftCode' && key != 'bankNameNoMatchBank'){
          flag = true
        }
      }
      return flag;
    },
    bankNameIsOtherBank(){
      return this.form.bankName == '其他银行'|| this.form.bankName == 'Other banks'|| this.form.bankName == '其他銀行';
    },
  },
  watch: {
    dialogShow: {
      handler(val){
        if(val){
          this.getCustomerInfo(true);
        }
      },
      immediate: true
    },
    custPayTypes: {
      handler(newVal) {
        if (newVal && this.dialogShow) {
          this.getCustomerInfo(true);
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['refreshCustPayTypes']),
    bankAccountInputHandle(){
      return this.form.bankAccount = this.form.bankAccount.replace(/\s+/g,'');
    },
    getBankList(isInit){
      let arg = {type: this.form.currency};
      if(this.form.currency == 'VND'){
        arg.type = 'vndWithdrawBankList';
      }
      if(this.form.currency == 'CNY'){
        arg.type = 'bankList';
      }
      if(this.form.currency == 'IDR'){
        arg.type = 'idrWithdrawBankList';
      }
      getDictListByType(arg).then((res) => {
        this.bankList = res.data;
        this.bankList.push({label: this.$t('User.OTHER_BANKS')});
        if(!isInit){
          this.form.bankAccount = "";
          this.form.bankName = "";
          this.form.bankNameNoMatchBank = "";
          this.form.bankOutlet = "";
          this.form.swiftCode = "";
          this.form.bankFrontUrl = "";
          this.form.bankBackUrl = "";
        }
      })
    },
    getCustomerInfo(itSTheFirstTime){
      const data = this.custPayTypes;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if(data[i].payTypeId == 4){
            this.allData = data[i].payDetailMap;
            this.assignForm(this.allData);
          }
        }
      }
      this.getBankList(itSTheFirstTime);
    },
    assignForm(allData){
      this.form.bankFrontUrl = allData.bankFrontImg;
      this.form.bankBackUrl = allData.bankBackImg;
      this.form.bankAccount = allData.bankAccount;
      this.form.bankOutlet = allData.bankOutlet;
      this.form.swiftCode = allData.swiftCode;
      this.form.currency = allData.currency;
      let someOne = this.bankList.some((item) => {
        return item.label == allData.bankName;
      });
      if(!someOne && this.language == 'zh_CN'){
        this.form.bankName = this.$t('User.OTHER_BANKS');
        this.form.bankNameNoMatchBank = allData.bankName;
      }else {
        this.form.bankName = allData.bankName;
      }
    },
    phFileter(data) {
      return this.$t(data);
    },
    // 上传银行卡前面
    uploadFront(item){

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);
        this.frontLoading = true;
        this.$uploadFile(file).then((res) => {
          this.frontLoading = false;
          this.form.bankFrontUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.frontLoading = false;
        })
      });

    },
    // 上传图片的限制
    beforeAvatarUpload(file){
      return limitImageSizeFormat(file,this);
    },
    uploadBack(item){

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);
        this.backLoading = true;
        this.$uploadFile(file).then((res) => {
          this.backLoading = false;
          this.form.bankBackUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.backLoading = false;
        })
      });

    },
    submitHandle(){
      if(this.userInfo.custStatus == 10){
        this.$message({
          message: this.$t('Please_activate_the_binding'),
          type: 'warning'
        });
        return
      }
      this.$refs.form.validate((valid) => {
        if(valid){
          if (!this.form.bankFrontUrl) {
            this.$message({
              message: this.$t('User.plsInputBankFront'),
              type: 'error'
            });
            return;
          }
          if (!this.form.bankBackUrl) {
            this.$message({
              message: this.$t('User.plsInputBankBack'),
              type: 'error'
            });
            return;
          }
          let parmas = {
            custId: this.userInfo.id,
            bankFrontImg: this.form.bankFrontUrl,
            bankBackImg: this.form.bankBackUrl,
            bankAccount: this.form.bankAccount,
            currency:this.form.currency,
            bankOutlet: this.form.bankOutlet,
            swiftCode: this.form.swiftCode,
          };
          if(this.bankNameIsOtherBank){
            parmas.bankName = this.form.bankNameNoMatchBank;
          }else {
            parmas.bankName = this.form.bankName;
          }
          commitBankcardImg(parmas).then(() => {
            return this.refreshCustPayTypes();
          }).then(() => {
            this.$message({
              message: this.$t('The_bank_card_information_has_been_submitted_successfully'),
              type: 'success'
            });

            this.$emit('ajax-success');
          });
        }
      })
    },
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    cancelHandle(){
      this.close();
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.bank-edit {
  .content {
    padding-top: 10px;
    .text-box {
      background-color: #F8F8F8;
      padding: 10px;
      border-radius: 6px;
      .text-box-line {
        margin-bottom: 10px;
        font-size: 14px;
        .text-left {
          color: #A29FAE;
        }
        .data-right {
          color: #6E6B7B;
        }
      }
    }
    .avatar-uploader-btn {
      font-size: 14px;
      color: #8c939d;
      width: 200px;
      height: 110px;
      line-height: 110px;
      text-align: center;
      background-color: #f5f5f5;
      border: 1px dotted #999;
    }
    .avatar {
      width: 200px;
      height: 110px;
      display: inline-block;
    }
    .upload-box {
      width: 200px;
    }
    .el-upload {
      width: 100%;
    }
    .el-form-item__label {
      line-height: 0;
    }
  }
  /deep/input[type="number"]::-webkit-inner-spin-button,
  /deep/input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }
}
</style>
<style lang="scss">
.bank-edit {
  .vs-sidebar--items {

  }
  .scroll-area--customizer {
    height: calc(100% - 4rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
// 移动端样式
@media screen and (max-width: 768px){
  .el-select-dropdown{
    .el-select-dropdown__item{
      max-width: 300px;
      white-space: normal;
      word-wrap: break-word;
      height: auto;
      line-height: 20px;
      margin-bottom: 8px;
    }
  }
}
</style>
